import { render, staticRenderFns } from "./WizardNew.vue?vue&type=template&id=1962fda6"
import script from "./WizardNew.vue?vue&type=script&lang=js"
export * from "./WizardNew.vue?vue&type=script&lang=js"
import style0 from "./WizardNew.vue?vue&type=style&index=0&id=1962fda6&prod&lang=scss"
import style1 from "./WizardNew.vue?vue&type=style&index=1&id=1962fda6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports